export default __webpack_public_path__ + "static/media/exchange.d7f8043e.svg";